(function () {
  'use strict';

  function lhParseHTML(htmlString) {
    return new DOMParser().parseFromString(htmlString, 'text/html');
  }

  function lhGetPageNumberFromUrl(url, fallbackPage) {
    try {
      const parsedUrl = new URL(url, window.location.origin);
      const page = parseInt(parsedUrl.searchParams.get('page') || '', 10);

      return page > 0 ? page : fallbackPage || 1;
    } catch (error) {
      return fallbackPage || 1;
    }
  }

  function lhBuildPageUrl(baseUrl, pageNumber) {
    try {
      const url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('page', String(pageNumber));
      return url.href;
    } catch (error) {
      return null;
    }
  }

  function lhBuildSectionRequestUrl(pageUrl, section) {
  if (!pageUrl || !section) return null;

  const sectionId = section.getAttribute('data-section-id');

  if (!sectionId) return null;

  try {
    const url = new URL(pageUrl, window.location.origin);

    /*
     * Shopify Section Rendering API
     *
     * 保留原来的：
     * page
     * sort_by
     * filter
     * products per page
     * 以及其他 query 参数
     *
     * 只额外增加当前 Collection Section ID。
     */
    url.searchParams.set('section_id', sectionId);

    return url.href;
  } catch (error) {
    return null;
  }
}

  function lhNormalizeUrl(url) {
    if (!url) return '';

    try {
      const parsedUrl = new URL(url, window.location.origin);
      parsedUrl.hash = '';
      return parsedUrl.href;
    } catch (error) {
      return String(url);
    }
  }

  function lhGetTotalPagesFromDoc(doc) {
    if (!doc) return null;

    const marker = doc.querySelector(
      '[data-lh-infinite-scroll][data-lh-total-pages], ' +
      '[data-lh-sold-out-page-marker][data-lh-total-pages], ' +
      '[data-lh-sku-recommend-page-marker][data-lh-total-pages]'
    );

    if (marker) {
      const pages = parseInt(marker.getAttribute('data-lh-total-pages'), 10);
      if (pages > 0) return pages;
    }

    const pageItems = doc.querySelectorAll(
      '.pagination__nav-item, .pagination a, .pagination span'
    );

    const pageNumbers = Array.from(pageItems)
      .map(function (el) {
        return parseInt((el.textContent || '').trim(), 10);
      })
      .filter(function (num) {
        return !isNaN(num);
      });

    if (pageNumbers.length) {
      return Math.max.apply(null, pageNumbers);
    }

    return null;
  }

  function lhGetProductHandleFromItem(item) {
    if (!item || item.nodeType !== 1) return null;

    const directHandle =
      item.getAttribute('data-lh-product-handle') ||
      item.dataset?.lhProductHandle ||
      '';

    if (directHandle) {
      return directHandle;
    }

    const productLink = item.querySelector('a[href*="/products/"]');
    if (!productLink) return null;

    try {
      const url = new URL(productLink.href, window.location.origin);
      const parts = url.pathname.split('/products/');

      if (!parts[1]) return null;

      return parts[1].split('/')[0].split('?')[0].split('#')[0];
    } catch (error) {
      const href = productLink.getAttribute('href') || '';
      const match = href.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    }
  }

  function lhIsProductTemplate(item) {
    if (!item || item.nodeType !== 1) return false;

    return item.matches(
      'template[data-lh-accessory-product-template], ' +
      'template[data-lh-sold-out-product-template], ' +
      'template[data-lh-sku-recommend-product-template]'
    );
  }

  function lhIsPageMarker(item) {
    if (!item || item.nodeType !== 1) return false;

    return item.matches(
      '[data-lh-sold-out-page-marker], ' +
      '[data-lh-sku-recommend-page-marker]'
    );
  }

  function lhBuildExistingProductHandleSet(productList) {
    const set = new Set();

    if (!productList) return set;

    Array.from(productList.children).forEach(function (item) {
      /*
      * 忽略隐藏商品模板。
      */
      if (lhIsProductTemplate(item)) {
        return;
      }

      /*
      * 忽略分页标记。
      */
      if (lhIsPageMarker(item)) {
        return;
      }

      const handle = lhGetProductHandleFromItem(item);

      if (handle) {
        set.add(handle);
      }
    });

    return set;
  }

  function lhCleanupInfinite(section) {
    if (!section) return;

    const oldRoot = section.querySelector('[data-lh-infinite-scroll]');

    if (oldRoot && typeof oldRoot._lhCleanup === 'function') {
      oldRoot._lhCleanup();
    }
  }

  function lhInitInfiniteForRoot(section, infiniteRoot) {
    if (!section || !infiniteRoot) return;
    if (infiniteRoot.dataset.lhBound === 'true') return;

    const productList = section.querySelector('[data-lh-main-product-list]');
    const paginationWrap = section.querySelector('[data-lh-pagination-wrap]');
    const sentinel = infiniteRoot.querySelector('[data-lh-sentinel]');
    const loadingEl = infiniteRoot.querySelector('[data-lh-loading]');
    const endEl = infiniteRoot.querySelector('[data-lh-end]');

    if (!productList || !paginationWrap || !sentinel) return;

    const loadedUrls = new Set();

    let isLoading = false;
    let observer = null;

    let lhTotalPages =
      parseInt(infiniteRoot.getAttribute('data-lh-total-pages'), 10) ||
      lhGetTotalPagesFromDoc(document) ||
      1;

    let lhCurrentLoadedPage =
      parseInt(infiniteRoot.getAttribute('data-lh-current-page'), 10) ||
      lhGetPageNumberFromUrl(window.location.href, 1);

    if (lhCurrentLoadedPage < 1) {
      lhCurrentLoadedPage = 1;
    }

    let nextPageUrl = null;

    if (lhCurrentLoadedPage < lhTotalPages) {
      nextPageUrl = lhBuildPageUrl(
        window.location.href,
        lhCurrentLoadedPage + 1
      );
    }

    infiniteRoot.setAttribute(
      'data-lh-total-pages-debug',
      String(lhTotalPages)
    );

    infiniteRoot.setAttribute(
      'data-lh-current-page',
      String(lhCurrentLoadedPage)
    );

    infiniteRoot.setAttribute(
      'data-lh-next-page-url',
      nextPageUrl || ''
    );

    infiniteRoot.removeAttribute('data-lh-ended');

    if (endEl) endEl.hidden = true;
    if (loadingEl) loadingEl.hidden = true;

    if (!nextPageUrl) {
      if (lhCurrentLoadedPage >= lhTotalPages) {
        if (endEl) endEl.hidden = false;
        infiniteRoot.setAttribute('data-lh-ended', 'true');
      } else {
        console.error(
          '[LH Infinite Scroll] Missing next URL before final page:',
          {
            currentPage: lhCurrentLoadedPage,
            totalPages: lhTotalPages
          }
        );

        paginationWrap.classList.remove('lh_is-hidden');
      }

      return;
    }

    paginationWrap.classList.add('lh_is-hidden');

    function lhStopInfinite() {
      nextPageUrl = null;

      infiniteRoot.setAttribute('data-lh-next-page-url', '');
      infiniteRoot.setAttribute('data-lh-ended', 'true');

      if (observer) observer.disconnect();
      if (endEl) endEl.hidden = false;
    }

    function lhShouldPreload() {
      const rect = sentinel.getBoundingClientRect();
      return rect.top <= window.innerHeight + 400;
    }

    function lhSetNextPageUrl(baseUrl) {
      if (lhCurrentLoadedPage >= lhTotalPages) {
        lhStopInfinite();
        return false;
      }

      nextPageUrl = lhBuildPageUrl(
        baseUrl,
        lhCurrentLoadedPage + 1
      );

      infiniteRoot.setAttribute(
        'data-lh-next-page-url',
        nextPageUrl || ''
      );

      if (!nextPageUrl) {
        console.error(
          '[LH Infinite Scroll] Failed to build next page URL:',
          lhCurrentLoadedPage + 1
        );

        paginationWrap.classList.remove('lh_is-hidden');

        if (observer) observer.disconnect();

        return false;
      }

      return true;
    }

    async function lhFetchPageWithRetry(url, attempt) {
      attempt = attempt || 0;

      const response = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (response.ok) {
        return response;
      }

      if (response.status === 429 && attempt < 3) {
        const retryAfter = parseInt(
          response.headers.get('Retry-After') || '',
          10
        );

        const delay = !isNaN(retryAfter) && retryAfter > 0
          ? retryAfter * 1000
          : 5000 * Math.pow(2, attempt);

        console.warn(
          '[LH Infinite Scroll] HTTP 429, retry page after ' +
          delay +
          'ms'
        );

        await new Promise(function(resolve) {
          setTimeout(resolve, delay);
        });

        return lhFetchPageWithRetry(
          url,
          attempt + 1
        );
      }

      throw new Error(
        'Failed to load next page. HTTP status: ' +
        response.status
      );
    }

    async function lhFetchCollectionPage(pageUrl) {
      const sectionUrl = lhBuildSectionRequestUrl(
        pageUrl,
        section
      );

      /*
      * 优先：
      * 只请求当前 Collection Section。
      */
      if (sectionUrl) {
        try {
          const response = await lhFetchPageWithRetry(
            sectionUrl,
            0
          );

          const html = await response.text();
          const doc = lhParseHTML(html);

          const productList = doc.querySelector(
            '[data-lh-main-product-list]'
          );

          /*
          * 只有确认关键结构存在，
          * 才接受 Section Response。
          *
          * 防止 Shopify 返回异常 HTML 时
          * Infinite Scroll 功能直接失效。
          */
          if (productList) {
            return {
              html: html,
              document: doc,
              productList: productList,
              requestMode: 'section'
            };
          }

          console.warn(
            '[LH Infinite Scroll] Section response missing product list. Falling back to full page.'
          );
        } catch (error) {
          console.warn(
            '[LH Infinite Scroll] Section request failed. Falling back to full page.',
            error
          );
        }
      }

      /*
      * 安全回退：
      *
      * 如果 Section Rendering API 出现任何问题，
      * 自动使用原来的整页请求。
      *
      * 功能完整优先。
      */
      const response = await lhFetchPageWithRetry(
        pageUrl,
        0
      );

      const html = await response.text();
      const doc = lhParseHTML(html);

      const productList = doc.querySelector(
        '[data-lh-main-product-list]'
      );

      if (!productList) {
        throw new Error(
          'Next page main product list not found'
        );
      }

      return {
        html: html,
        document: doc,
        productList: productList,
        requestMode: 'full-page-fallback'
      };
    }

    async function lhLoadNextPage() {
      if (isLoading || !nextPageUrl) return;

      const currentUrl = nextPageUrl;
      const normalizedCurrentUrl = lhNormalizeUrl(currentUrl);

      if (!normalizedCurrentUrl) {
        console.error(
          '[LH Infinite Scroll] Invalid next page URL:',
          currentUrl
        );
        return;
      }

      if (loadedUrls.has(normalizedCurrentUrl)) {
        console.warn(
          '[LH Infinite Scroll] Duplicate request blocked:',
          normalizedCurrentUrl
        );

        if (lhCurrentLoadedPage >= lhTotalPages) {
          lhStopInfinite();
          return;
        }

        lhSetNextPageUrl(currentUrl);
        return;
      }

      loadedUrls.add(normalizedCurrentUrl);
      isLoading = true;

      infiniteRoot.classList.add('lh_is-loading');

      if (loadingEl) {
        loadingEl.hidden = false;
      }

      try {
        const pageResult = await lhFetchCollectionPage(
          currentUrl
        );

        const html = pageResult.html;
        const nextDocument = pageResult.document;
        const nextProductList = pageResult.productList;

        const existingHandles =
          lhBuildExistingProductHandleSet(productList);

        const fragment = document.createDocumentFragment();

        let addedNodeCount = 0;
        let addedProductCount = 0;
        let addedTemplateCount = 0;
        let addedMarkerCount = 0;

        Array.from(nextProductList.children).forEach(function (item) {
          const handle = lhGetProductHandleFromItem(item);

          /*
          * 分页 marker：
          * 直接加入，用于推荐和缺货脚本判断页码。
          */
          if (lhIsPageMarker(item)) {
            fragment.appendChild(item);

            addedNodeCount++;
            addedMarkerCount++;

            return;
          }

          /*
          * 推荐、配件和缺货模板：
          *
          * 模板不是页面上真实显示的商品卡片，
          * 所以不能把它的 handle 放进 existingHandles。
          *
          * 否则后面同 handle 的真实商品卡片
          * 会被误判成重复商品。
          */
          if (lhIsProductTemplate(item)) {
            fragment.appendChild(item);

            addedNodeCount++;
            addedTemplateCount++;

            return;
          }

          /*
          * 以下才是真实商品卡片的去重逻辑。
          */
          if (handle && existingHandles.has(handle)) {
            return;
          }

          if (handle) {
            existingHandles.add(handle);
            addedProductCount++;
          }

          fragment.appendChild(item);
          addedNodeCount++;
        });

        if (addedNodeCount > 0) {
          section._lhAppendingProducts = true;
          productList.appendChild(fragment);

          setTimeout(function () {
            section._lhAppendingProducts = false;
          }, 150);
        }

        const loadedPageMarker = nextDocument.querySelector(
          '[data-lh-infinite-scroll][data-lh-current-page], ' +
          '[data-lh-sku-recommend-page-marker], ' +
          '[data-lh-sold-out-page-marker]'
        );

        let loadedPageNumber = lhGetPageNumberFromUrl(
          currentUrl,
          lhCurrentLoadedPage + 1
        );

        if (loadedPageMarker) {
          const markerPage = parseInt(
            loadedPageMarker.getAttribute('data-lh-current-page') ||
            loadedPageMarker.getAttribute('data-lh-page') ||
            '',
            10
          );

          const markerTotalPages = parseInt(
            loadedPageMarker.getAttribute('data-lh-total-pages') || '',
            10
          );

          if (markerPage > 0) {
            loadedPageNumber = markerPage;
          }

          if (markerTotalPages > 0) {
            lhTotalPages = markerTotalPages;
          }
        }

        lhCurrentLoadedPage = Math.max(
          lhCurrentLoadedPage,
          loadedPageNumber
        );

        infiniteRoot.setAttribute(
          'data-lh-current-page',
          String(lhCurrentLoadedPage)
        );

        infiniteRoot.setAttribute(
          'data-lh-total-pages-debug',
          String(lhTotalPages)
        );

        console.log(
          '[LH Infinite Scroll] loaded:',
          lhCurrentLoadedPage,
          '/',
          lhTotalPages,
          {
            productCards: addedProductCount,
            templates: addedTemplateCount,
            markers: addedMarkerCount,
            totalNodes: addedNodeCount
          }
        );

        if (lhCurrentLoadedPage >= lhTotalPages) {
          lhStopInfinite();
          return;
        }

        /*
         * Build the following page URL from the URL that was just loaded.
         * This preserves sort, filter, view and products-per-page parameters.
         */
        lhSetNextPageUrl(currentUrl);

        if (addedNodeCount === 0) {
          console.warn(
            '[LH Infinite Scroll] Page loaded but no new nodes were appended:',
            currentUrl
          );
        }
      } catch (error) {
        loadedUrls.delete(normalizedCurrentUrl);

        console.error('[LH Infinite Scroll]', error);

        paginationWrap.classList.remove('lh_is-hidden');

        if (observer) {
          observer.disconnect();
        }
      } finally {
        isLoading = false;

        infiniteRoot.classList.remove('lh_is-loading');

        if (loadingEl) {
          loadingEl.hidden = true;
        }

        setTimeout(function () {
          if (
            !isLoading &&
            nextPageUrl &&
            lhShouldPreload()
          ) {
            lhLoadNextPage();
          }
        }, 250);
      }
    }

    observer = new IntersectionObserver(
      function (entries) {
        const entry = entries[0];

        if (!entry || !entry.isIntersecting) return;

        lhLoadNextPage();
      },
      {
        root: null,
        rootMargin: '0px 0px 400px 0px',
        threshold: 0
      }
    );
    /*
    * 开始监听底部观察点
    */
    observer.observe(sentinel);

      /*
      * 保存当前加载函数到 infiniteRoot。
      * 这样外部重置时可以直接调用下一页加载，
      * 不需要完全依赖 IntersectionObserver 再次触发。
      */
      infiniteRoot._lhLoadNextPage = lhLoadNextPage;

      /*
      * 保存位置检测函数，供重新初始化时使用。
      */
      infiniteRoot._lhShouldPreload = lhShouldPreload;

      /*
      * 标记观察器已绑定。
      */
      infiniteRoot.dataset.lhBound = 'true';

      /*
      * 绑定完成后立即检查一次。
      *
      * 当前问题中 sentinel 已经在可视区域内：
      * sentinelTop = 313
      * viewportHeight = 481
      *
      * 所以重新绑定后应该立即请求下一页，
      * 而不是继续等待新的滚动动作。
      */
      requestAnimationFrame(function () {
        if (
          !isLoading &&
          nextPageUrl &&
          lhShouldPreload()
        ) {
          lhLoadNextPage();
        }
      });

      infiniteRoot._lhCleanup = function () {
        if (observer) {
          observer.disconnect();
        }

        /*
        * 观察器断开后同步清除状态。
        * 避免 DOM 显示 bound=true，
        * 但实际上观察器已经断开。
        */
        infiniteRoot.dataset.lhBound = 'false';

        /*
        * 删除旧闭包中的函数引用。
        */
        delete infiniteRoot._lhLoadNextPage;
        delete infiniteRoot._lhShouldPreload;
      }
    }

  function lhSetupSection(section) {
    if (!section) return;

    lhCleanupInfinite(section);

    const infiniteRoot = section.querySelector(
      '[data-lh-infinite-scroll]'
    );

    if (!infiniteRoot) return;

    infiniteRoot.dataset.lhBound = 'false';

    lhInitInfiniteForRoot(section, infiniteRoot);
  }

  function lhObserveDynamicPart(section) {
    if (!section) return;
    if (section._lhDynamicObserved === true) return;

    const dynamicPart = section.querySelector(
      '.collection__dynamic-part'
    );

    if (!dynamicPart) return;

    let timer = null;

    const mutationObserver = new MutationObserver(function (mutations) {
      if (section._lhAppendingProducts === true) return;

      const shouldReset = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          if (node.nodeType !== 1) return false;

          return (
            node.matches?.('[data-lh-infinite-scroll]') ||
            node.matches?.('[data-lh-pagination-wrap]') ||
            node.querySelector?.('[data-lh-infinite-scroll]') ||
            node.querySelector?.('[data-lh-pagination-wrap]')
          );
        });
      });

      if (!shouldReset) return;

      clearTimeout(timer);

      timer = setTimeout(function () {
        lhSetupSection(section);
      }, 120);
    });

    mutationObserver.observe(dynamicPart, {
      childList: true,
      subtree: false
    });

    section._lhDynamicObserved = true;
    section._lhDynamicObserver = mutationObserver;
  }

  function lhInitAllSections() {
    document
      .querySelectorAll('[data-section-type="collection"]')
      .forEach(function (section) {
        lhSetupSection(section);
        lhObserveDynamicPart(section);
      });
  }
  /*
 * 手动强制请求下一页。
 *
 * 控制台可以执行：
 * window.LH_LOAD_NEXT_COLLECTION_PAGE()
 */
window.LH_LOAD_NEXT_COLLECTION_PAGE =
  function () {
    var infiniteRoot = document.querySelector(
      '[data-lh-infinite-scroll]'
    );

    if (!infiniteRoot) {
      console.error(
        '[LH Infinite Scroll] Infinite root not found.'
      );

      return false;
    }

    if (
      typeof infiniteRoot._lhLoadNextPage !==
      'function'
    ) {
      console.warn(
        '[LH Infinite Scroll] Loader is not active. Reinitializing.'
      );

      lhInitAllSections();

      setTimeout(function () {
        var refreshedRoot =
          document.querySelector(
            '[data-lh-infinite-scroll]'
          );

        if (
          refreshedRoot &&
          typeof refreshedRoot._lhLoadNextPage ===
            'function'
        ) {
          refreshedRoot._lhLoadNextPage();
        }
      }, 100);

      return true;
    }

    infiniteRoot._lhLoadNextPage();

    return true;
  };

  function lhReadyInit() {
    lhInitAllSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      lhReadyInit,
      { once: true }
    );
  } else {
    lhReadyInit();
  }

  document.addEventListener(
    'lh:collection:updated',
    function () {
      setTimeout(function () {
        if (
          typeof window.LH_FORCE_REBOOT_INFINITE_SCROLL === 'function'
        ) {
          window.LH_FORCE_REBOOT_INFINITE_SCROLL();
        } else {
          lhInitAllSections();
        }
      }, 250);
    }
  );

    /*
    * 手动重置无限滚动。
    *
    * 不再调用可能由其他旧脚本定义的
    * window.LH_FORCE_REBOOT_INFINITE_SCROLL。
    *
    * 直接使用当前文件自己的初始化函数，
    * 避免被推荐、缺货或配件脚本截走。
    */
    document.addEventListener(
      'lh:collection:infinite-reset',
      function () {
        setTimeout(function () {
          lhInitAllSections();
        }, 100);
      }
    );

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const section = event.target;

      if (!section) return;

      if (section.matches('[data-section-type="collection"]')) {
        lhSetupSection(section);
        lhObserveDynamicPart(section);
        return;
      }

      const nestedCollection = section.querySelector(
        '[data-section-type="collection"]'
      );

      if (nestedCollection) {
        lhSetupSection(nestedCollection);
        lhObserveDynamicPart(nestedCollection);
      }
    }
  );

  document.addEventListener('click', function (event) {
    const button = event.target.closest(
      '.value-picker__choice-item[data-action="select-value"]'
    );

    if (!button) return;

    setTimeout(function () {
      lhInitAllSections();
    }, 500);
  });
})();